import { render, staticRenderFns } from "./InputPassword.vue?vue&type=template&id=4b2ec0ba&"
import script from "./InputPassword.vue?vue&type=script&lang=js&"
export * from "./InputPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports